module.exports = __webpack_public_path__ + "img/img01.656df32e.png";